// extracted by mini-css-extract-plugin
export default {"cellPadColumn":"ZygPEp_sTJCuUO8ZSSbj"};